module.exports = __webpack_public_path__ + "assets/img/driver-btn-f1226e7c.png";